<template>
  <div class="pageContent">
    <div class="reportList">
      <van-notice-bar scrollable text="温馨提示：本服务提供的资料仅供快捷浏览，报告内容以纸质报告为准，如需医学判断，请咨询医生。" />
      <div class="total">
        <span>您当前共有{{total}}份检查结果</span>
        <!-- <span class="return">
          <van-icon name="plus" @click="toSelect" />
        </span> -->
      </div>
      <remoteList
        :listData="listData"
        @getReportInfo="getReportInfo"
        @getWechatPay="getWechatPay"
        @callReportPrint="callReportPrint"
      />
    </div>
  </div>
</template>

<script>
import remoteList from "@/components/remoteList/index.vue";
import {
  getAllRemote,
  getReportInfo,
  ready2RemotePay,
  getLocalReport
} from "@/api/report";
import Storage from "@/tools/storage";
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "reportList",
  components: { remoteList },
  data() {
    return {
      listData: [],
      total: 0
    };
  },
  methods: {
    async getAllReport() {
      let res = await getAllRemote();
      if (res) {
        this.listData = res;
        this.total = res.length;
      }
    },
    async getReportInfo(params) {
      Storage.set("examId", params.exam_id);
      let res = await getReportInfo(params);
      if (res) {
        Storage.set("reportInfo", res);
        // Storage.set('studyId', res[0].study_id)
        Storage.set("code", 1);
        this.$router.push({ path: "/reportInfo/report" });
      }
    },
    wechatPay() {
      let _this = this;
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["chooseWXPay"]
          });
          wx.chooseWXPay({
            timestamp: _this.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: _this.nonceStr, // 支付签名随机串，不长于 32 位
            package: _this.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: _this.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: _this.paySign, // 支付签名
            success: function(res) {
              _this.getAllReport();
              // 支付成功后的回调函数
            }
          });
        });
    },
    async getWechatPay(params) {
      let res = await ready2RemotePay(params);
      if (res) {
        console.log(res);
        this.nonceStr = res.nonceStr;
        this.package = res.package;
        this.paySign = res.paySign;
        this.signType = res.signType;
        this.timeStamp = res.timeStamp;
        this.wechatPay();
      }
    },
    async callReportPrint(item) {
      const ra_id = item.ra_id;
      const exam_status = item.report_status;
      if (exam_status != 9) {
        alert("报告未确认,无法查看报告");
        return;
      }
      // let res = await getLocalReport()
      this.$router.push({
        path: "/print",
        query: { ra_id: ra_id, from: "remoteList" }
      });
    },
    toSelect() {
      this.$router.push({ path: "/select" });
    }
  },
  created() {
    this.getAllReport();
  }
};
</script>
<style lang="scss" scoped>
.reportList {
  height: 100%;
  width: 100%;
  background: #eeeeee;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  color: #000;
  .total {
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    color: #000;
    .return {
      width: 30px;
      font-size: 15px;
      color: #51cde4;
    }
  }
}
</style>
